export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: '韩漫' | '日漫' | '国漫' | '其他';
  tags: string[];
  rating: number;
  description: string;
  status: '连载中' | '已完结';
  updatedAt: string;
  chapters: Chapter[];
  views: number;
  favorites: number;
}

export interface Chapter {
  id: number;
  title: string;
  updatedAt: string;
}

export const categories = ['全部', '韩漫', '日漫', '国漫', '其他'] as const;

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / Jang Sung-rak',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20illustration%20featuring%20a%20powerful%20male%20protagonist%20with%20dark%20hair%20and%20glowing%20blue%20eyes%20in%20a%20dungeon%20setting%2C%20dramatic%20lighting%2C%20action%20pose%2C%20dark%20fantasy%20style%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: '韩漫',
    tags: ['奇幻', '动作', '冒险'],
    rating: 9.7,
    description: '在一个突然出现"门"连接异次元的世界里，被称为"猎人"的人类拥有了各种超能力。成振宇作为最弱的E级猎人，在一次双重地下城事故中濒临死亡，但却获得了神秘的系统能力，开始了"独自升级"的传奇之路。',
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 觉醒', updatedAt: '2026-07-01' },
      { id: 2, title: '第2话 系统', updatedAt: '2026-07-03' },
      { id: 3, title: '第3话 日常任务', updatedAt: '2026-07-05' },
      { id: 4, title: '第4话 地下城', updatedAt: '2026-07-08' },
      { id: 5, title: '第5话 成长', updatedAt: '2026-07-12' },
      { id: 6, title: '第6话 新的力量', updatedAt: '2026-07-18' },
      { id: 7, title: '第7话 危机', updatedAt: '2026-07-25' },
      { id: 8, title: '第8话 突破', updatedAt: '2026-08-01' },
    ],
    views: 12850000,
    favorites: 892000,
  },
  {
    id: 2,
    title: '咒术回战',
    author: '芥见下下',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20cover%20illustration%20featuring%20a%20spiky%20haired%20teenage%20boy%20with%20supernatural%20energy%20surrounding%20him%2C%20dark%20urban%20fantasy%20style%2C%20dynamic%20action%20pose%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: '日漫',
    tags: ['战斗', '超自然', '校园'],
    rating: 9.5,
    description: '虎杖悠仁是一名拥有超强体能的高中生，为了解救被诅咒困扰的前辈，他吞下了特级咒物"宿傩的手指"，从此踏入了咒术师的世界。在东京都立咒术高等专门学校，他与伙伴们一起对抗诅咒，守护人类的和平。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 虎杖悠仁', updatedAt: '2026-06-15' },
      { id: 2, title: '第2话 咒术高专', updatedAt: '2026-06-18' },
      { id: 3, title: '第3话 初次任务', updatedAt: '2026-06-22' },
      { id: 4, title: '第4话 诅咒之王', updatedAt: '2026-06-28' },
      { id: 5, title: '第5话 交流会', updatedAt: '2026-07-05' },
      { id: 6, title: '第6话 涉谷事变', updatedAt: '2026-07-15' },
    ],
    views: 15600000,
    favorites: 1020000,
  },
  {
    id: 3,
    title: '一人之下',
    author: '米二',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20cover%20illustration%20featuring%20a%20young%20man%20with%20supernatural%20martial%20arts%20powers%20in%20modern%20Chinese%20setting%2C%20traditional%20Taoist%20elements%2C%20dynamic%20action%20pose%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: '国漫',
    tags: ['奇幻', '武侠', '搞笑'],
    rating: 9.4,
    description: '普通大学生张楚岚因爷爷尸体被盗而卷入异人世界，结识了神秘少女冯宝宝。在异人世界的冒险中，他逐渐揭开了甲申之乱的真相，也发现了自己身上隐藏的秘密。',
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 异人', updatedAt: '2026-06-10' },
      { id: 2, title: '第2话 冯宝宝', updatedAt: '2026-06-14' },
      { id: 3, title: '第3话 罗天大醮', updatedAt: '2026-06-20' },
      { id: 4, title: '第4话 对决', updatedAt: '2026-06-27' },
      { id: 5, title: '第5话 真相', updatedAt: '2026-07-05' },
    ],
    views: 9800000,
    favorites: 750000,
  },
  {
    id: 4,
    title: '全职猎人',
    author: '富坚义博',
    cover: 'https://readdy.ai/api/search-image?query=A%20classic%20Japanese%20manga%20cover%20illustration%20featuring%20a%20young%20boy%20with%20spiky%20green%20hair%20holding%20a%20fishing%20rod%2C%20adventure%20fantasy%20style%2C%20bright%20energetic%20colors%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: '日漫',
    tags: ['冒险', '战斗', '奇幻'],
    rating: 9.8,
    description: '小杰为了寻找父亲金·富力士，决心参加猎人考试成为猎人。在旅途中他结识了奇犽、酷拉皮卡和雷欧力等伙伴，一同经历了无数的冒险与挑战，探索这个充满未知的广阔世界。',
    status: '连载中',
    updatedAt: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 出发之日', updatedAt: '2026-05-20' },
      { id: 2, title: '第2话 暴风雨中', updatedAt: '2026-05-25' },
      { id: 3, title: '第3话 猎人考试', updatedAt: '2026-06-01' },
      { id: 4, title: '第4话 最终测试', updatedAt: '2026-06-10' },
    ],
    views: 21000000,
    favorites: 1500000,
  },
  {
    id: 5,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20featuring%20a%20stunning%20girl%20with%20long%20brown%20hair%20and%20perfect%20makeup%2C%20romantic%20school%20drama%20style%2C%20soft%20warm%20lighting%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: '韩漫',
    tags: ['恋爱', '校园', '喜剧'],
    rating: 9.1,
    description: '因为相貌平凡而受到欺负的林周京，通过化妆技巧华丽变身为校园女神。然而当素颜的秘密随时可能暴露时，她在两个男生之间展开了充满甜蜜与纠结的校园恋爱故事。',
    status: '已完结',
    updatedAt: '2026-06-15',
    chapters: [
      { id: 1, title: '第1话 化妆的力量', updatedAt: '2026-03-01' },
      { id: 2, title: '第2话 新的开始', updatedAt: '2026-03-05' },
      { id: 3, title: '第3话 素颜危机', updatedAt: '2026-03-12' },
      { id: 4, title: '第4话 两个他', updatedAt: '2026-03-20' },
    ],
    views: 18500000,
    favorites: 1280000,
  },
  {
    id: 6,
    title: '斗罗大陆',
    author: '唐家三少 / 穆逢春',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20manhua%20cover%20featuring%20a%20young%20warrior%20with%20blue%20silver%20grass%20martial%20spirit%2C%20ancient%20Chinese%20fantasy%20world%2C%20epic%20adventure%20style%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: '国漫',
    tags: ['奇幻', '武侠', '热血'],
    rating: 9.6,
    description: '唐门外门弟子唐三因偷学内门绝学被逼跳崖，却意外穿越到了斗罗大陆。在这个武魂的世界里，他凭借前世的记忆和天赋，一步步走向巅峰，成为最强的魂师。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 1, title: '第1话 穿越', updatedAt: '2026-04-01' },
      { id: 2, title: '第2话 武魂觉醒', updatedAt: '2026-04-05' },
      { id: 3, title: '第3话 史莱克学院', updatedAt: '2026-04-12' },
      { id: 4, title: '第4话 七怪集结', updatedAt: '2026-04-20' },
    ],
    views: 22000000,
    favorites: 1680000,
  },
  {
    id: 7,
    title: '间谍过家家',
    author: '远藤达哉',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20spy%20comedy%20manga%20cover%20featuring%20a%20family%20of%20three%20a%20suited%20spy%20man%20an%20assassin%20woman%20and%20a%20pink%20haired%20telepathic%20girl%2C%20retro%20stylish%20design%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: '日漫',
    tags: ['喜剧', '间谍', '家庭'],
    rating: 9.7,
    description: '西国最强间谍"黄昏"为了执行任务，需要组建一个临时家庭。他找来杀手妻子约尔和超能力女儿阿尼亚，三人各自隐藏真实身份，在谎言中开始了奇妙的家庭生活。',
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 任务开始', updatedAt: '2026-05-01' },
      { id: 2, title: '第2话 女儿入学', updatedAt: '2026-05-08' },
      { id: 3, title: '第3话 家庭日常', updatedAt: '2026-05-15' },
    ],
    views: 14200000,
    favorites: 1100000,
  },
  {
    id: 8,
    title: '整容游戏',
    author: '金阳秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20thriller%20manhwa%20cover%20featuring%20a%20mysterious%20masked%20figure%20with%20intense%20eyes%2C%20dark%20psychological%20style%2C%20suspenseful%20atmosphere%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: '韩漫',
    tags: ['悬疑', '惊悚', '剧情'],
    rating: 9.3,
    description: '一款神秘的手机APP"整容游戏"突然出现在人们的手机中，它声称可以按照用户意愿改变任何人的外貌。但随着使用这个APP的人越来越多，一系列诡异的事件开始发生。',
    status: '连载中',
    updatedAt: '2026-07-30',
    chapters: [
      { id: 1, title: '第1话 APP', updatedAt: '2026-04-15' },
      { id: 2, title: '第2话 变化', updatedAt: '2026-04-20' },
      { id: 3, title: '第3话 代价', updatedAt: '2026-04-28' },
    ],
    views: 7600000,
    favorites: 520000,
  },
  {
    id: 9,
    title: '镖人',
    author: '许先哲',
    cover: 'https://readdy.ai/api/search-image?query=A%20gritty%20Chinese%20historical%20manhua%20cover%20featuring%20a%20scarred%20swordsman%20in%20ancient%20Chinese%20attire%2C%20ink%20wash%20painting%20style%2C%20dark%20atmospheric%20tone%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20manga%20art%20style&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    category: '国漫',
    tags: ['历史', '武侠', '硬核'],
    rating: 9.8,
    description: '隋末唐初，大业三年。一个身手不凡的镖客刀马，带着小七行走于西域大漠之中。他为了还债接下了一趟危险的镖，却因此卷入了朝廷、武林和西域势力之间的巨大阴谋。',
    status: '连载中',
    updatedAt: '2026-07-25',
    chapters: [
      { id: 1, title: '第1话 大漠刀客', updatedAt: '2026-03-10' },
      { id: 2, title: '第2话 知世郎', updatedAt: '2026-03-18' },
      { id: 3, title: '第3话 镖', updatedAt: '2026-03-26' },
    ],
    views: 6500000,
    favorites: 480000,
  },
  {
    id: 10,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20demon%20slayer%20manga%20cover%20featuring%20a%20young%20swordsman%20with%20burgundy%20hair%20and%20a%20green%20checkered%20haori%2C%20water%20breathing%20effects%2C%20dark%20fantasy%20style%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    category: '日漫',
    tags: ['战斗', '奇幻', '热血'],
    rating: 9.6,
    description: '大正时代的日本，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子变成了鬼。为了让妹妹恢复成人类，炭治郎踏上了成为鬼杀队剑士的道路，与各种强大的鬼展开生死搏斗。',
    status: '已完结',
    updatedAt: '2026-05-20',
    chapters: [
      { id: 1, title: '第1话 残酷', updatedAt: '2026-02-01' },
      { id: 2, title: '第2话 培育师', updatedAt: '2026-02-08' },
      { id: 3, title: '第3话 最终选拔', updatedAt: '2026-02-15' },
    ],
    views: 25000000,
    favorites: 1800000,
  },
  {
    id: 11,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20school%20drama%20manhwa%20cover%20featuring%20a%20split%20face%20of%20a%20handsome%20and%20ordinary%20boy%2C%20dual%20identity%20theme%2C%20modern%20school%20setting%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    category: '韩漫',
    tags: ['校园', '剧情', '成长'],
    rating: 9.2,
    description: '因为长相丑陋而长期遭受校园霸凌的朴亨锡，某天醒来发现自己拥有了一个完美的身体。白天他以帅气的外表生活，晚上则变回原来的样子，在两个身份之间游走的他逐渐看清了这个"看脸"的世界。',
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 两个身体', updatedAt: '2026-05-10' },
      { id: 2, title: '第2话 新学校', updatedAt: '2026-05-15' },
      { id: 3, title: '第3话 双面人生', updatedAt: '2026-05-22' },
    ],
    views: 11200000,
    favorites: 860000,
  },
  {
    id: 12,
    title: '狐妖小红娘',
    author: '小新',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20romantic%20fantasy%20manhua%20cover%20featuring%20a%20beautiful%20fox%20spirit%20girl%20with%20red%20hair%20and%20traditional%20Chinese%20dress%2C%20ancient%20Chinese%20aesthetic%2C%20dreamy%20atmosphere%2C%20clean%20simple%20background%20with%20subtle%20gradient%2C%20professional%20anime%20art%20style&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    category: '国漫',
    tags: ['爱情', '奇幻', '古风'],
    rating: 9.5,
    description: '在人妖共存的世界里，狐妖小红娘涂山苏苏为前世恋人牵线搭桥，帮助他们再续前缘。而她自己与道士白月初之间，也隐藏着跨越千年的情缘秘密。',
    status: '连载中',
    updatedAt: '2026-07-29',
    chapters: [
      { id: 1, title: '第1话 红线仙', updatedAt: '2026-04-10' },
      { id: 2, title: '第2话 前世今生', updatedAt: '2026-04-15' },
      { id: 3, title: '第3话 续缘', updatedAt: '2026-04-22' },
    ],
    views: 8900000,
    favorites: 690000,
  },
];

export const featuredComicIds = [1, 2, 6, 10, 7];

export const hotComicIds = [1, 10, 6, 4, 7, 2, 3, 5];

export const latestComicIds = [2, 1, 6, 11, 5, 3, 7, 8, 12, 9, 4, 10];